import * as React from "react";

const CustomLeftArrow = ({ onClick }) => (
  <i onClick={() => onClick()} className="custom-left-arrow" />
);
const CustomRightArrow = ({ onClick }) => {
  return <i className="custom-right-arrow" onClick={() => onClick()} />;
};

export { CustomLeftArrow, CustomRightArrow };



// WEBPACK FOOTER //
// ./src/components/Layout/custom.js